import React from "react";

import styles from "./DesktopApp.module.scss";

export const CardContainer: React.FC<
  React.AnchorHTMLAttributes<HTMLAnchorElement> & { disabled?: boolean }
> = ({ disabled, children, className, ...rest }) => (
  <a
    className={`${styles.cardContainer} ${disabled ? "disabled" : ""} ${className ?? ""}`}
    {...rest}>
    {children}
  </a>
);

export const PageContent: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.pageContent} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const CardsRow: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.cardsRow} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const FlexColumn: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.flexColumn} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const SystemImage: React.FC<
  React.ImgHTMLAttributes<HTMLImageElement>
> = ({ className, alt = "", ...props }) => (
  <img className={`${styles.systemImage} ${className ?? ""}`} alt={alt} {...props} />
);
